export const hourArray = [
  { value: 0, label: '00' },
  { value: 1, label: '01' },
  { value: 2, label: '02' },
  { value: 3, label: '03' },
  { value: 4, label: '04' },
  { value: 5, label: '05' },
  { value: 6, label: '06' },
  { value: 7, label: '07' },
  { value: 8, label: '08' },
  { value: 9, label: '09' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
  { value: 12, label: '12' },
  { value: 13, label: '13' },
  { value: 14, label: '14' },
  { value: 15, label: '15' },
  { value: 16, label: '16' },
  { value: 17, label: '17' },
  { value: 18, label: '18' },
  { value: 19, label: '19' },
  { value: 20, label: '20' },
  { value: 21, label: '21' },
  { value: 22, label: '22' },
  { value: 23, label: '23' },
]

export const minuteArray = [
  { value: '0', label: '00' },
  { value: '5', label: '05' },
  { value: '10', label: '10' },
  { value: '15', label: '15' },
  { value: '20', label: '20' },
  { value: '25', label: '25' },
  { value: '30', label: '30' },
  { value: '35', label: '35' },
  { value: '40', label: '40' },
  { value: '45', label: '45' },
  { value: '50', label: '50' },
  { value: '55', label: '55' },
]

export const waitTimes = [
  { value: '0', label: '0  hours', type: 'hours' },
  { value: '1', label: '1  hour', type: 'hours' },
  { value: '2', label: '2  hours', type: 'hours' },
  { value: '3', label: '3  hours', type: 'hours' },
  { value: '4', label: '4  hours', type: 'hours' },
  { value: '5', label: '5  hours', type: 'hours' },
  { value: '6', label: '6  hours', type: 'hours' },
  { value: '7', label: '7  hours', type: 'hours' },
  { value: '8', label: '8  hours', type: 'hours' },
  { value: '9', label: '9  hours', type: 'hours' },
  { value: '10', label: '10  hours', type: 'hours' },
  { value: '00', label: '0  minutes', type: 'minutes' },
  { value: '05', label: '5  minutes', type: 'minutes' },
  { value: '10', label: '10  minutes', type: 'minutes' },
  { value: '15', label: '15  minutes', type: 'minutes' },
  { value: '20', label: '20  minutes', type: 'minutes' },
  { value: '25', label: '25  minutes', type: 'minutes' },
  { value: '30', label: '30  minutes', type: 'minutes' },
  { value: '35', label: '35  minutes', type: 'minutes' },
  { value: '40', label: '40  minutes', type: 'minutes' },
  { value: '45', label: '45  minutes', type: 'minutes' },
  { value: '50', label: '50  minutes', type: 'minutes' },
  { value: '55', label: '55  minutes', type: 'minutes' },
]

export const asDirectedHours = [
  { value: '1', label: '01 hour / 30KM / 20miles' },
  { value: '2', label: '02 hours / 60KM / 40miles' },
  { value: '3', label: '03 hours / 90KM / 60miles' },
  { value: '4', label: '04 hours / 120KM / 80miles' },
  { value: '5', label: '05 hours / 150KM / 100miles' },
  { value: '6', label: '06 hours / 180KM / 120miles' },
  { value: '7', label: '07 hours / 210KM / 140miles' },
  { value: '8', label: '08 hours / 240KM / 160miles' },
  { value: '9', label: '09 hours / 270KM / 180miles' },
  { value: '10', label: '10 hours / 300KM / 200miles' },
  { value: '11', label: '11 hours / 330KM / 220miles' },
  { value: '12', label: '12 hours / 360KM / 240miles' },
  { value: '13', label: '13 hours / 390KM / 260miles' },
  { value: '14', label: '14 hours / 420KM / 280miles' },
  { value: '15', label: '15 hours / 450KM / 300miles' },
  { value: '16', label: '16 hours / 480KM / 320miles' },
  { value: '17', label: '17 hours / 510KM / 340miles' },
  { value: '18', label: '18 hours / 540KM / 360miles' },
  { value: '19', label: '19 hours / 570KM / 380miles' },
  { value: '20', label: '20 hours / 600KM / 400miles' },
  { value: '21', label: '21 hours / 630KM / 420miles' },
  { value: '22', label: '22 hours / 660KM / 440miles' },
  { value: '23', label: '23 hours / 690KM / 460miles' },
  { value: '24', label: '24 hours / 720KM / 480miles' },
]
